module.exports = __webpack_public_path__ + "static/img/user.38de806f.gif";